import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'white-dashed-button',
  templateUrl: 'white-dashed-button.component.html',
  styleUrls: ['./white-dashed-button.component.less', './../../common.less'],
})

export class WhiteDashedButtonComponent implements OnInit {
  @Input() buttonText: string = "";
  @Input() buttonPlus: boolean = false;
  @Input() customWidthPx: number;
  @Input() customWidthPercent: number;
  @Output() addChoiceEvent = new EventEmitter<boolean>();

  addChoice() {
    this.addChoiceEvent.emit(true)
  }

  ngAfterViewChecked() {
    if (this.customWidthPx != undefined) {
      const buttonElement = document.getElementsByClassName("publish-button-invalid")
      const button = buttonElement[0] as HTMLElement
      button.style.width = this.customWidthPx + "px"
    }
    if (this.customWidthPercent != undefined) {
      const buttonElement = document.getElementsByClassName("publish-button-invalid")
      const button = buttonElement[0] as HTMLElement
      button.style.width = this.customWidthPercent + "%"
    }
  }

  ngOnInit() {

      
  }
}
